export const STUDIO = {
  name: "Sové",
  full: "Sové Skin Studio",
  tagline: "A home skin studio in Boronia",
  location: "Boronia, Melbourne · VIC, Australia",
  phoneDisplay: "0420 386 886",
  phone: "0420386886",
  instagram: "@sove_skin_studio",
  instagramUrl: "https://instagram.com/sove_skin_studio",
  email: "soveskinstudio@gmail.com",
  address: "By appointment · Boronia, Melbourne",
};

export const CHAPTERS = [
  {
    n: "01",
    title: "A quiet ritual",
    body:
      "Sové is a home-based studio — an intimate space away from the noise of the salon floor. Every appointment is one-on-one, unhurried, and shaped entirely around your skin.",
  },
  {
    n: "02",
    title: "Considered, not clinical",
    body:
      "We believe great skin is built slowly. Treatments are tailored, honest and results-driven, using gentle professional-grade formulas that respect your barrier.",
  },
  {
    n: "03",
    title: "Boronia born",
    body:
      "Tucked into the foothills of the Dandenongs, Sové brings a considered, editorial approach to skin, brows and lashes for the eastern suburbs of Melbourne.",
  },
];

export const SERVICE_GROUPS = [
  {
    key: "facials",
    label: "Essential Facials",
    items: [
      { name: "Hydra Glow Facial", desc: "Hydration · Radiance", price: "$139", time: "60 min" },
      { name: "Deep Clean Facial", desc: "Congestion · Hydration", price: "$129", time: "60 min" },
    ],
  },
  {
    key: "signature",
    label: "Signature Facials",
    sublabel: "Korean professional-grade skin treatments",
    items: [
      { name: "Skin Renewal Facial", desc: "Hydration · Barrier Repair · Radiance", price: "$155", time: "75 min" },
      { name: "Acne Reset Facial", desc: "Clarifying · Oil Control · Acne Care", price: "$155", time: "75 min" },
      { name: "Barrier Recovery Facial", desc: "Sensitive Skin · Restore · Repair", price: "$155", time: "75 min" },
      { name: "Peptide Lift Facial", desc: "Firming · Lifting · Anti-Ageing", price: "$165", time: "75 min" },
    ],
  },
  {
    key: "brows",
    label: "Eyebrow Tattoo",
    items: [
      { name: "Ombré Powder Brows", desc: "Soft, powdered gradient for a defined finish", price: "$299" },
      { name: "Hair Stroke Brows", desc: "Natural, hair-like strokes for realistic fullness", price: "$350" },
      { name: "Combo Brows", desc: "The best of powder & hair stroke techniques", price: "$399" },
      { name: "Brow Shape + Tint", desc: "Sculpted, tinted & beautifully groomed", price: "$30" },
    ],
  },
  {
    key: "lashes",
    label: "Lash Treatment",
    items: [
      { name: "Lash Lift", desc: "Your own lashes, lifted and curled", price: "$65" },
      { name: "Lash Lift + Tint", desc: "Lifted, curled & darkened for definition", price: "$75" },
    ],
  },
  {
    key: "addons",
    label: "Add-ons Treatment",
    items: [
      { name: "30-Min Relaxation Back Massage", desc: "A soothing add-on to unwind and reset", price: "$65" },
    ],
  },
];

export const ALL_SERVICES = SERVICE_GROUPS.flatMap((g) => g.items.map((i) => i.name));
